<template>
    <div>
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <h3 class="text-center">Update Ambassador <span class="smh"></span></h3>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="m-1 p-3">
            <div class="">
                {{ useambassadorsarray }}
              <form @submit.prevent="updateambassador">
                  
                  <b-form-group
                      label="Referral Code"
                      class="label"
                      label-for="Referal_code"
                  >
                      <b-form-input
                      type="text"
                      id="referral_code"
                      v-model="ambassador.referral_code"
                      ></b-form-input>
                  </b-form-group>
  
                  <b-form-group
                      label="Email"
                      class="label"
                      label-for="email"
                  >
                      <b-form-input
                          type="email"
                          id="email"
                          v-model="ambassador.email"
                      >
                      </b-form-input>
                  </b-form-group>
                  <b-form-group
                      label="First Name"
                      class="label"
                      label-for="first_name"
                  >
                      <b-form-input
                      type="text"
                      id="first_name"
                      v-model="ambassador.first_name"
                      ></b-form-input>
                  </b-form-group>
  
                  <b-form-group
                      label="Last Name"
                      class="label"
                      label-for="last_name"
                >
                  <b-form-input
                    type="text"
                    id="last_name"
                    v-model="ambassador.last_name"
                  ></b-form-input>
                </b-form-group>
  
                <b-form-group
                  label="Whatsapp Number"
                  class="label"
                  label-for="waphone"
                >
                  <b-form-input
                    type="text"
                    id="waphone"
                    v-model="ambassador.waphone"
                  ></b-form-input>
                </b-form-group>
  
                <b-form-group label="Location" class="label" label-for="location">
                  <b-form-input
                    type="text"
                    id="location"
                    v-model="ambassador.location"
                  ></b-form-input>
                </b-form-group>
  
                <b-form-group label="Gender">
                  <b-form-radio
                    v-model="ambassador.gender"
                    name="gender"
                    value="male"
                    >Male</b-form-radio
                  >
                  <b-form-radio
                    v-model="ambassador.gender"
                    name="gender"
                    value="female"
                    >Female</b-form-radio
                  >
                </b-form-group>
  
                <b-form-group label="Marital Status">
                  <b-form-radio
                    v-model="ambassador.marital_status"
                    name="marital_status"
                    value="single"
                    >Single</b-form-radio
                  >
                  <b-form-radio
                    v-model="ambassador.marital_status"
                    name="marital_status"
                    value="married"
                    >Married</b-form-radio
                  >
                </b-form-group>
  
                <b-form-group
                  label="Target (Sec School, Higher Institution or Tutorial Academy)"
                  class="label"
                  label-for="target"
                >
                  <b-form-input
                    type="text"
                    id="target"
                    v-model="ambassador.target"
                  ></b-form-input>
                </b-form-group>
  
                <b-form-group label="Occupation" class="label" label-for="target">
                  <b-form-input
                    type="text"
                    id="occupation"
                    v-model="ambassador.occupation"
                  ></b-form-input>
                </b-form-group>
  
                <b-form-group
                  label="Account Name"
                  class="label"
                  label-for="target"
                >
                  <b-form-input
                    type="text"
                    id="acct_name"
                    @input="uppercasename()"
                    v-model="ambassador.acct_name"
                  ></b-form-input>
                </b-form-group>
  
                <b-form-group
                  label="Account Bank Name"
                  class="label"
                  label-for="target"
                >
                  <b-form-input
                    type="text"
                    id="acct_bank"
                    v-model="ambassador.acct_bank"
                  ></b-form-input>
                </b-form-group>
  
                <b-form-group
                  label="Account Number"
                  class="label"
                  label-for="target"
                >
                  <b-form-input
                    type="text"
                    id="acct_type"
                    v-model="ambassador.acct_number"
                  ></b-form-input>
                </b-form-group>
  
                <b-form-group
                  label="Account Type"
                  class="label"
                  label-for="target"
                >
                  <b-form-select v-model="ambassador.acct_type">
                    <b-form-select-option value="null"
                      >--Select Type--</b-form-select-option
                    >
                    <b-form-select-option value="SAVINGS"
                      >SAVINGS</b-form-select-option
                    >
                    <b-form-select-option value="CURRENT"
                      >CURRENT</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
  
  
  
                <b-form-group label="Ambassador Status">
                  <b-form-radio
                    v-model="ambassador.ambassador_status"
                    name="status"
                    value="active"
                    >Active</b-form-radio
                  >
                  <b-form-radio
                    v-model="ambassador.status"
                    name="status"
                    value="suspended"
                    >Suspended</b-form-radio
                  >
                  <b-form-radio
                      v-model="ambassador.status"
                      name="status"
                      value="terminated"
                      >Terminated</b-form-radio
                  >
                </b-form-group>
  
                <b-overlay :show="uploadingsponsor">
                  <template #overlay>
                    <div class="text-center">
                      <b-icon-file-image
                        font-scale="3"
                        animation="throb"
                      ></b-icon-file-image>
                      <p>Uploading Image...</p>
                    </div>
                  </template>
                  <b-form-group>
                    <b-form-file
                      v-model="ambassador.profile_image"
                      ref="file"
                      placeholder="Choose a file or drop it here"
                      drop-placeholder="Drop File here..."
                      @input="handleImage"
                    ></b-form-file>
                  </b-form-group>
                  <img :src="ambassador.profile_image" class="image-attachment" />
                </b-overlay>
  
                <div v-if="sent" class="alert alert-success p-3">
                  Ambassador Updated Successfully
                </div>
  
                <div class="text-center">
                  <b-overlay
                    :show="sending"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class=""
                  >
                    <div class="mt-4">
                      <b-button
                        :disabled="chkfields"
                        type="submit"
                        variant="outline-success"
                        class="m-lg-3 mt-2 p-2 action-button"
                      >
                        Update Ambassador
                      </b-button>
                    </div>
                  </b-overlay>
                  <b-button
                    v-if="sending"
                    @click="sending = false"
                    class="w-50 p-2 mt-3"
                    variant="dark"
                  >
                    Cancel
                  </b-button>
                </div>
              </form>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>
  
  <script>
  import { mapActions, mapState } from "vuex";
  import store from "@/store";
  
  export default {
    data() {
      return {
        ambassador: this.getForm(),
        sending: false,
        sent: false,
        levels: [0, 1, 2, 3, 4, 5],
        startnum: 0,
        limitnum: this.endss,
        intervalnum: 10,
        endnum: 10,
        btnrange: this.endss,
        pages: 1,
        stockingdata: [
          {
            data: []
          }
        ],
        dataretrieved: false,
        addresponse: "",
        opencreate: false,
        // editor : ClassicEditor,
        // config : config,
        isCheckingcode: false,
        ambassadorexists: false,
        uploadingfile: false,
        uploadedfile: false,
        uploadmessage: "",
        mtype: "",
        filedir: "",
        uploadingsponsor: false
        // datacount : this.partnershipsarray[0].count
      };
    },
    beforeRouteEnter(to, from, next) {
      //   let orgname = store.state.loginmaster.details.clearance_organization
      store.dispatch("admin/fetchAmbassadors");
      next();
    },
    mounted() {
        // let email = this.$route.params.email;
        // let currentambassador = this.ambassadorsarray[0].data.filter(
        // x => x.email == email
        // )[0];

        // this.ambassador = {
        //     referral_code : currentambassador.refcode,
        //     email : currentambassador.email,
        //     first_name: currentambassador.first_name,
        //     last_name: currentambassador.last_name,
        //     waphone: currentambassador.wphone,
        //     location: currentambassador.location,
        //     occupation: currentambassador.occupation,
        //     target : currentambassador.target,
        //     profile_image: currentambassador.profile_image,
        //     gender: currentambassador.gender,
        //     status: currentambassador.status,
        //     marital_status: currentambassador.marital_status,
        //     acct_type: currentambassador.acct_type,
        //     acct_name: currentambassador.acct_name,
        //     acct_bank: currentambassador.acct_bank,
        //     acct_number: currentambassador.acct_number
        // };
    },
    computed: {
      ...mapState({
        users: state => state.admin.allusers,
        details: state => state.loginmaster.details,
        ambassadorsarray: state => state.admin.ambassadors,
        adminadded: state => state.admin.adminadded,
        environ: state => state.loginmaster.environ,
        origin: state => state.loginmaster.api_origin
      }),
    //   useambassadorsarray() {
    //     return this.ambassadorsarray[0][this.ambassadorshowing]
    //   },
      chkfields() {
        if (
          // this.ambassadorexists ||
          this.sending ||
          this.ambassador.first_name.length <= 0 ||
          this.ambassador.last_name.length <= 0 ||
          this.ambassador.wphone.length <= 0 ||
          this.ambassador.location.length <= 0 ||
          this.ambassador.email.length <= 0 ||
          this.ambassador.status.length <= 0 ||
          this.ambassador.profile_image.length <= 0 ||
          this.ambassador.referral_code.length <= 0 ||
          this.ambassador.gender.length <= 0 ||
          this.ambassador.marital_status.length <= 0
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    methods: {
      ...mapActions("admin", [
        "addAmbassadors",
        "checkAmbassador",
        "fetchAmbassadors",
        "editAmbassador"
      ]),
      getForm() {
        return {
          referral_code : "",
          email : "",
          first_name: "",
          last_name: "",
          waphone: "",
          location: "",
          occupation: "",
          target : "",
          profile_image: "",
          gender: "",
          status: "active",
          marital_status: "",
          acct_type: "",
          acct_name: "",
          acct_bank: "",
          acct_number: "",
          ambassadorshowing : "ambdata"
        };
      },
      handleImage() {
        this.uploadingsponsor = true;
        let ifile = this.$refs.file.files[0];
        this.imageUpload(ifile).then(() => {
          if (this.status == "success") {
            this.uploadingsponsor = false;
            this.$bvModal
              .msgBoxOk(
                "Image Uploaded Successfully. Proceed with Question Upload.",
                {
                  title: "Image Uploaded",
                  size: "xs",
                  centered: true
                }
              )
              .then(() => {});
            this.ambassador.profile_image = this.url;
            this.attachmentfiles = this.url;
          }
        });
      },
      updateambassador() {
        this.sending = true;
        // this.user.organization = this.details.clearance_organization
      //   this.ambassadors.adminname = this.details.fullname;
  
        return this.addAmbassadors(this.ambassador).then(() => {
          this.sending = false;
          this.sent = true;
  
          // this.create.title = "";
          // this.create.description = "";
          // this.create.target = "";
          // this.create.ambassadorcode = "";
  
          this.fetchAmbassadors();
        });
      },
      newPage(page) {
        // alert(page)
        this.pages = page;
        let newend = this.intervalnum * page;
  
        if (newend < this.endss) {
          this.endnum = newend;
          this.startnum = newend - this.intervalnum;
        } else {
          this.endnum = this.endss;
          this.startnum = newend - this.intervalnum;
        }
      },
      effectInterval(newinterval) {
        this.intervalnum = newinterval;
        this.pages = 1;
        this.newPage(this.pages);
      },
  
      checkCouponcode() {
        this.create.ambassadorcode = this.create.ambassadorcode.toUpperCase();
  
        if (this.create.ambassadorcode.length > 0) {
          this.isCheckingcode = true;
        } else {
          this.isCheckingcode = false;
        }
  
        // alert(this.create.ambassadorcode)
  
        return this.checkCoupon(this.create.ambassadorcode).then(response => {
          this.ambassadorexists = response;
          // console.log(response)
        });
      },
      stopproceed() {
        this.sending = false;
      }
    }
  };
  </script>
  
  <style scoped>
  .list-heads {
    background-color: #00984a;
    color: white;
    border-radius: 5px 5px;
    font-weight: bold;
    display: flex;
    flex-flow: row wrap;
  }
  .head-p {
    width: 11%;
    padding: 2px;
  }
  .flex-input-parent {
    display: flex;
  }
  .left-flex-child {
    width: 95%;
  }
  .right-flex-child {
    width: 5%;
  }
  .hidden {
    display: none;
  }
  .full-width-child {
    width: 100%;
  }
  .font-green {
    color: green;
  }
  .errtxt {
    color: red;
  }
  
  .image-attachment {
    width: 80px;
    height: 80px;
  }
  
  @media screen and (max-width: 999px) {
    .head-p {
      font-size: 0.6rem;
    }
    .page-buttons {
      width: 25px;
      height: 25px;
      padding: 0px 0px 0px 5px;
    }
  }
  </style>
  